import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

function relicNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "relic", next, x, y });
}

// 第13期。集中で磨いた各チームを、自律的に連携させる四半期。
// 左右の運用方針は中盤まで混ざらず、共有の連携ポイントを通った時だけ別の出口へ渡れる。
// レリックはその連携ルートの終盤に1つだけ置く。
export const MAP_NODES_AUTONOMY: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["u1"], x: 3, y: 0 }),
  u1: caseNode("u1", ["u2l", "u2r"], 3, 1),
  u2l: caseNode("u2l", ["u3a", "rest3b"], 1, 2),
  u2r: caseNode("u2r", ["u3d", "e3e"], 5, 2),
  u3a: caseNode("u3a", ["u4a"], 0, 3),
  "rest3b": restNode("rest3b", ["u4b"], 2, 3),
  u3d: caseNode("u3d", ["u4d"], 5, 3),
  e3e: eventNode("e3e", ["u4e"], 6, 3),
  u4a: caseNode("u4a", ["u5a"], 0, 4),
  u4b: caseNode("u4b", ["u5a"], 2, 4),
  u4d: caseNode("u4d", ["u5c"], 4, 4),
  u4e: caseNode("u4e", ["rest5d"], 6, 4),
  u5a: caseNode("u5a", ["u6a"], 1, 5),
  u5c: caseNode("u5c", ["u6d"], 5, 5),
  "rest5d": restNode("rest5d", ["u6d"], 6, 5),
  u6a: caseNode("u6a", ["u7a", "u7b"], 1, 6),
  u6d: caseNode("u6d", ["u7b", "e7c"], 5, 6),
  u7a: caseNode("u7a", ["rest9l"], 0, 7),
  u7b: caseNode("u7b", ["relic8b"], 3, 7),
  e7c: eventNode("e7c", ["u8a"], 6, 7),
  "relic8b": relicNode("relic8b", ["rest9l"], 3, 8),
  u8a: caseNode("u8a", ["rest9r"], 5, 8),
  "rest9l": restNode("rest9l", ["boss"], 1, 9),
  "rest9r": restNode("rest9r", ["boss"], 5, 9),
  boss: node("boss", { kind: "case", caseId: "autonomy-boss", next: [], x: 3, y: 10 }),
};
